import Snackbar from "@mui/material/Snackbar";
import { Button } from "@mui/material";
import "./snackbar.scss";
import { useDispatch } from "react-redux";
import { setErrorDisplay } from "../../state/actions/globalAction";

const SnackBar = ({ error }) => {
  const dispatch = useDispatch();
  const closeHandler = () => {
    dispatch(setErrorDisplay(""));
  };
  return (
    <Snackbar
      open={error}
      autoHideDuration={3000}
      onClose={closeHandler}
      message={error}
      action={
        <Button className="dismiss-btn" size="small" onClick={closeHandler}>
          Dismiss
        </Button>
      }
    />
  );
};

export default SnackBar;
